const styles = {
  backgroundContainer: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  logoContainer: {
    position: 'absolute',
    top: 40,
    left: 40,
    width: 64,
    height: 56,
    '& img': {
      width: '100%',
    },
  },
  loginAnimationContainer: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
}

export default styles
